const enum Language {
  ES_ES = "es_es",
  EN = "en",
}
const DEFAULT_LANGUAGE: Language = Language.ES_ES;

export { DEFAULT_LANGUAGE, Language };

export const Languages: { title: string; value: Language }[] = [
  { title: "Español", value: Language.ES_ES },
  { title: "Inglés", value: Language.EN },
];
